var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormRender',{attrs:{"form":_vm.form,"Service":_vm.Service}},[_c(_vm.current,{tag:"component",attrs:{"form":_vm.form,"formFields":_vm.formFields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }